import createMuiTheme from './createMuiTheme';
const defaultTheme = createMuiTheme();
export default defaultTheme;